import styles from "@/elements-react/product-element-refactor/product-element.module.scss";
import ProductStatus from "@/elements-react/product-status";
import { t } from "i18next";
import { LayoutStyleTypes } from "@/util-react/layout";
import { HasPropertyType } from "@/elements-react/product-element-refactor/useProductElement";

export interface ProductElementStatusStockFactoryProps {
  type?: LayoutStyleTypes.TYPE_LG | LayoutStyleTypes.TYPE_SM | LayoutStyleTypes.TYPE_MD;
}

interface ProductElementStatusStockProps {
  type?: LayoutStyleTypes.TYPE_LG | LayoutStyleTypes.TYPE_SM | LayoutStyleTypes.TYPE_MD;
  productStatus: string;
  onRequest: boolean;
  noPrice: boolean;
}

export const productElementStatusStockPropsFactory = (
  props: ProductElementStatusStockFactoryProps & { hasProperty: (type: HasPropertyType) => boolean },
): ProductElementStatusStockProps => {
  const { type, hasProperty } = props;
  let productStatus = "";

  if (hasProperty("outOfStock")) {
    productStatus = "out-stock-not-available-for-order";
  } else if (hasProperty("inStock")) {
    productStatus = "in-stock";
  }

  return {
    type,
    productStatus,
    onRequest: hasProperty("onRequest"),
    noPrice: hasProperty("noPrice"),
  };
};

export const ProductElementStatusStock = (props: ProductElementStatusStockProps) => {
  const { type, productStatus, onRequest, noPrice } = props;

  return (
    <div className={styles.statuses}>
      {productStatus && <ProductStatus status={productStatus} type={type} />}
      {onRequest && <div className={styles.badge}>{t("3b91531d.onRequest", "On request")}</div>}
      {noPrice && <div className={styles["request-price"]}>{t("o8s7grb7gfwviwg7.contact-to-request", "Contact us to request a price")}</div>}
    </div>
  );
};
